import axios from '../../../../api/axios'
import React,{useState,useEffect} from 'react'
import {useParams} from 'react-router-dom'
import Formulaire from '../../../ModelesPages/Modele1/Formulaire'
import Sweetalert2 from 'react-sweetalert2'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../ContextApp/AuthContext'


function Update(){
    const {user}=useAuth()
    const [eleve,setEleve]=useState([])
    const [adresse,setAdresse]=useState("");
    const [Count,setCount]=useState(0);
    const [inscriptions,setInscriptions]=useState([])
    const [lieu_naissance,setLieu_naissance]=useState("")
    const [date_naissance,setDate_naissance]=useState("")
    const [nom,setNom]=useState("");
    const [postnom,setPostnom]=useState("");
    const [prenom,setPrenom]=useState("");
    const [classes,setClasses]=useState([])
    const [my_classe,setMy_classe]=useState("")
    const [sexe,setSexe]=useState("");
    const [numero_serni,setNumero_serni]=useState("");
    const [nom_complet,setNom_complet]=useState("")
    const [status_code,setStatus_code]=useState()
    const [status_message,setStatus_message]=useState("")
    const [swalProps,setSwalProp]=useState({})
    const navigate=useNavigate()
    function HandleAlert(){
        setSwalProp({
            show:true,
            title:'Mis à jour',
            icon:'success',
            didClose:()=>{
                navigate('/Elèves')
            }
        })
            
    }
    const {id}=useParams()
    useEffect(()=>{
         HandleRequest()
         handle_classe_request()
         handle_inscription_request()
    },[])
    
    function handleMouse(e){

        e.target.textContent="Bonjour"
    }
    function handleMouseleave(e){
        e.target.textContent="Soumettre"
    }
    function handlekeyUpgain(e){
    
        const elementss=e.nextElementSibling;
      
    }
    function handleclick(){
        alert('You have clicked me')
    }
    const Alert_confirm_submit=async(e)=>{
       
        if(Number(my_classe) !== Number(inscriptions.idclasse)){    
        Swal.fire({
            title:'Confirmation de soumission',
            icon:'question',    
            text:'Vous venez de changer la classe de l\'élève, tous les points de ce dernier dans la classe modifiée ne seront plus pris en compte. Voulez-vous toujours enregistrer les modifications ?',
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonColor:'success',
            confirmButtonText:'Confirmer'
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                HandleSubmit()
            }
        })
        }
        else {
            HandleSubmit()
        }
        
    }
    const HandleSubmit= async (e)=>{
       
        await axios.put(`api/eleves/${id}`,{nom:nom.toLowerCase(),postnom:postnom.toLowerCase(),prenom:prenom.toLowerCase(),sexe:sexe,adresse:adresse.toLowerCase(),lieu_naissance:lieu_naissance.toLowerCase(),date_naissance:date_naissance,numero_serni:numero_serni,nom_complet:nom_complet.toLowerCase(),idinscription:inscriptions.id,idclasse:my_classe,idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire,ideleve:id}).then((res)=>{
            setStatus_message(res.data.status_message)
            setStatus_code(res.data.status_code)
                if(status_code===200){
                   HandleAlert()
                  
               }
        }).catch((err)=>{
            
        })
    }
    const handle_inscription_request=async()=>{
        try{
            await axios.post('api/getinscription',{ideleve:id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
                setInscriptions(res.data.item)
                setMy_classe(res.data.item.idclasse)
            })
        }   
        catch(e){

        }  
        }
    const handle_classe_request=async()=>{
            try{
                await axios.post('api/classes_getter',{idecole:user?.ecole?.id}).then((res)=>{
    
                    setClasses(res.data.items)
                })
            }
            catch(e){
    
            }
        }
   const HandleRequest=async ()=>{
        await axios.get(`api/eleves/${id}`).then((res)=>{
            console.log(res)
                setStatus_code(res.data.status_code)
                setNom(res.data.eleve.nom)
                setPostnom(res.data.eleve.postnom)
                setPrenom(res.data.eleve.prenom)
                setSexe(res.data.eleve.sexe)
                setAdresse(res.data.eleve.adresse)
                setLieu_naissance(res.data.eleve.lieu_naissance)
                setDate_naissance(res.data.eleve.date_naissance)
                setNom_complet(res.data.eleve.nom_complet)
                setNumero_serni(res.data.eleve.Numero_serni)
                
                  
        }).catch((err)=>{
            
        })
    }
    const RenderData=()=>{
           
                return(
                    <Formulaire title="Formulaire de Mise à jour" id={id} Alert_confirm_submit={Alert_confirm_submit} onclick={handleclick} classes={classes} setClasses={setClasses} my_classe={my_classe} setMy_classe={setMy_classe} setNom={setNom} handlekeyUpgain={handlekeyUpgain} setPostnom={setPostnom} setPrenom={setPrenom} setSexe={setSexe} setDate_naissance={setDate_naissance} setLieu_naissance={setLieu_naissance} nom={nom} postnom={postnom} prenom={prenom} sexe={sexe} date_naissance={date_naissance} lieu_naissance={lieu_naissance} handleMouse={handleMouse} Count={Count} setCount={setCount} handleMouseleave={handleMouseleave} HandleSubmit={HandleSubmit} setNumero_serni={setNumero_serni} numero_serni={numero_serni} adresse={adresse} setAdresse={setAdresse} setNom_complet={setNom_complet} >
                    <div className="col-md-6">
                        <label className="form-label" for="grid-first-name">
                            NOM COMPLET : <span class="obligatoire">*</span>
                        </label>
                        <input className="form-control form-control-lg" id="grid-first-name" type="text" placeholder="Akonkwa Ganywamulume Jean-Claude" name="nom_complet" value={nom_complet} />
                    <div id="resultat" className="block text-red-700"></div>
                    <div id="erreur" className="block text-red-500"></div>
                    </div>
                </Formulaire>
                )
                
         }
    
   return(
        <>      
            <div>
                {RenderData()}
            </div>
           <Sweetalert2 {...swalProps}>
                    <h3 className='text-primary'>
                        {status_message}
                    </h3>
           </Sweetalert2>
          
        </>
    )
}
export default Update